import { useEffect, useState } from 'react';
import { GridEnrichedColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import { useSelector } from 'react-redux';
import { getProfile } from '../../../store/auth/selector';
import { isAuthAdmin } from '../../../service/Auth';
import ActionCell from './ActionCell';
import moment from 'moment';

const useProductColumn = (offset = 0, setSelectedUser?: (val: any) => void) => {
  const [column, setColumn] = useState<GridEnrichedColDef[]>([]);
  const authProfile = useSelector(getProfile);
  const isAdmin = isAuthAdmin(authProfile);
  useEffect(() => {
    const defaultColumns: GridEnrichedColDef[] = [
      {
        field: 'STT',
        width: 100,
        sortable: false,
        renderCell: (index) => index.api.getRowIndexRelativeToVisibleRows(index.row.id) + offset + 1
      },
      {
        field: 'name',
        headerName: 'Tên',
        flex: 1,
        sortable: false
      },
      {
        field: 'price',
        headerName: 'Giá',
        sortable: false,
        headerAlign: 'left',
        align: 'left',
        flex: 1
      },
      {
        field: 'shortDes',
        headerName: 'Quy cách sản phẩm',
        sortable: false,
        headerAlign: 'left',
        align: 'left',
        flex: 1
      },
      {
        field: 'manufacturingDate',
        headerName: 'Ngày sản xuất',
        sortable: false,
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        valueGetter: (params) => params.row.manufacturingDate ?  moment(params.row.manufacturingDate).format('DD-MM-YYYY') : ''
      },
      {
        field: 'expiredDate',
        headerName: 'Ngày hết hạn',
        sortable: false,
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        valueGetter: (params) => params.row.expiredDate ? moment(params.row.expiredDate).format('DD-MM-YYYY') : ''
      }
    ]
    if (isAdmin) {
      defaultColumns.push(
          {
            field: 'actionCell',
            headerName: 'Action',
            flex: 1,
            sortable: false,
            renderCell: (params) => (ActionCell(params, setSelectedUser))
          });
    }
    setColumn([...defaultColumns]);
  }, [offset]);
  return column;
}

export default useProductColumn;
